module.exports = __webpack_public_path__ + "img/保利发展控股.a562c104.png";